import PropTypes from 'prop-types';
import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { EMPTY_PROPERTY_VALUE } from '../constants/EmptyPropertyValue';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const getPaymentStatusAvatar = value => {
  switch (value) {
    case 'succeeded':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "success",
        "data-test-id": `status-dot-${value}`
      });
    case 'failed':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "error",
        "data-test-id": `status-dot-${value}`
      });
    case 'processing':
    case 'processing_refund':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "inReview",
        "data-test-id": `status-dot-${value}`
      });
    case 'refunded':
    case 'partially_refunded':
      return /*#__PURE__*/_jsx(UIStatusDot, {
        use: "thunderdome",
        "data-test-id": `status-dot-${value}`
      });
    default:
      return undefined;
  }
};
const FormattedPaymentStatus = ({
  property,
  value,
  objectTypeId
}) => {
  if (value === null || value === undefined) {
    return /*#__PURE__*/_jsx("span", {
      children: EMPTY_PROPERTY_VALUE
    });
  }
  return /*#__PURE__*/_jsxs("span", {
    children: [getPaymentStatusAvatar(value), getDisplayedValue(property, value, undefined, undefined, objectTypeId)]
  });
};
FormattedPaymentStatus.propTypes = {
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};
export default FormattedPaymentStatus;